import React, { useMemo } from 'react';
import { TextField } from '@mui/material';

import { Props } from './props';

const CreditCardInputView: React.FC<Props> = (props) => {
  const { onChange, value, name, ...rest } = props;
  const maxLength = 16;

  const formattedValue = useMemo(() => {
    return value
      ?.replace(/\D/g, '')
      ?.replace(/(\d{4})(?=\d)/g, '$1 ')
      ?.trim();
  }, [value]);

  return (
    <TextField
      name={name}
      value={formattedValue}
      onChange={onChange}
      inputProps={{ maxLength: maxLength + 3 }}
      {...rest}
    />
  );
};

// trim spaces
export const creditCardTrim = (value: string) => {
  return value.replace(/\s/g, '');
};

export type CreditCardInputProps = Props;
export const CreditCardInput = CreditCardInputView;
export default CreditCardInputView;
